import React, {useState, useEffect, useRef} from 'react';
import './ChatNotification.scss';
import chatBotIcon from 'assets/images/chatbot.svg';
import {useSelector, useDispatch} from 'react-redux';
import {storage} from '../../services/config/storage';
import chatAPI from '../../services/chatData';
import {showChatNotification} from '../../store/company/actions';

function ChatNotification(props) {
    const dispatch = useDispatch();
    const {user} = useSelector(({global}) => global);
    const chatMsgNotifications = useSelector(
        ({company}) => company.showNotifications,
    );
    const showChatBot = useSelector(({company}) => company.showChatBot);

    const [showMessages, setShowMessages] = useState(false);
    const openChatMessage = (item) => {
        const entityType =
            // item.entityType.toLowerCase() !== 'company'
            //     ? 'industry'
            //     : 'company';
            item.entityType.toLowerCase() !== 'company'
                ? 'IndustryTemplate'
                : 'company';
        props.history.push(`/${entityType}/${item.entityId}`);
        setShowMessages(false);
    };

    const listOpenConversatonsFunc = async () => {
        try {
            let res = await chatAPI.listOpenConversatons();
            let messageNotifications = res.filter((item) => item.notifyUser);
            showChatNotification(messageNotifications || [])(dispatch);
        } catch (error) {
            console.error('listOpenConversatonsFunc ', error);
        }
    };

    const _checkOngoingChats = () => {
        const {
            userAccess: {chatAccess},
        } = user;
        const _hasChatAccess = chatAccess === 'full';
        _hasChatAccess && listOpenConversatonsFunc();
    };

    useEffect(() => {
        _checkOngoingChats();
    }, []);

    useInterval(() => {
        _checkOngoingChats();
    }, 30000);

    return (
        !showChatBot &&
        chatMsgNotifications.length > 0 && (
            <div className="chat-notifications-component">
                <div
                    className="icon"
                    onClick={() => setShowMessages(!showMessages)}
                >
                    <div>
                        <div className="notifications-count">
                            {chatMsgNotifications.length}
                        </div>
                        <img src={chatBotIcon} alt="chat-bot" />
                    </div>
                </div>

                {showMessages && chatMsgNotifications.length > 0 && (
                    <div className="message-window">
                        <div className="msgHeader">
                            <div className="msg-heading">Messages</div>
                            <div
                                className="closeBtn"
                                onClick={() => setShowMessages(false)}
                            >
                                X
                            </div>
                        </div>
                        <div className="scroll-msg">
                            {chatMsgNotifications.map((item, index) => (
                                <div
                                    className="msg-item"
                                    key={index}
                                    onClick={() => openChatMessage(item)}
                                >
                                    <div>{item.companyName}</div>
                                    <div>
                                        {item.analystFirstName +
                                            ' ' +
                                            item.analystLastName}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        )
    );
}

function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}

export default ChatNotification;
